import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Footer() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      <footer className="bg-heading text-white py-8 px-4" data-id="element-56">
        <div className="max-w-6xl mx-auto flex flex-col items-center gap-4 text-center" data-id="element-57">
          {/* Sponsor logos */}
          <div className="flex items-center justify-center gap-6" data-id="element-58">
            <div className="bg-white rounded-lg p-2 h-14 flex items-center justify-center" data-id="element-59">
              <img src="https://cdn.magicpatterns.com/uploads/wkgK3TfUfV2kt1gG4bGoYo/logo_Dra_Ysalismar.png" alt="Dra. Ysailis Martínez" className="max-h-10 max-w-[80px] object-contain" data-id="element-60" />
            </div>
            <div className="bg-white rounded-lg p-2 h-14 flex items-center justify-center" data-id="element-61">
              <img src="https://cdn.magicpatterns.com/uploads/dVddGeVW64T3Smy2i85CP7/Logo_Centro_medico_Especializado_Profem.jpg" alt="Centro Médico Especializado Profem" className="max-h-10 max-w-[80px] object-contain" data-id="element-62" />
            </div>
          </div>

          <p className="text-xs text-white/90" data-id="element-63">
            Avalado por Dra. Ysailis Martinez @draysailismartinez · Centro
            Médico Profem @profemm.ccs
          </p>

          <p className="text-sm md:text-base" data-id="element-64">
            © 2025 Candidiasis Vaginal: Lo Que Debes Saber · Todos los derechos
            reservados
          </p>
          <button onClick={() => setIsOpen(true)} className="text-sm md:text-base underline underline-offset-4 hover:text-accent-blush transition-colors" data-id="element-65">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-66">
        {isOpen && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={() => setIsOpen(false)} role="dialog" aria-modal="true" aria-labelledby="terms-title" data-id="element-67">
            <motion.div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col" initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} onClick={e => e.stopPropagation()} data-id="element-68">
              <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-gray-100" data-id="element-69">
                <h2 id="terms-title" className="font-heading text-2xl md:text-3xl font-bold text-heading" data-id="element-70">
                  Términos y Condiciones
                </h2>
                <button onClick={() => setIsOpen(false)} aria-label="Cerrar" className="text-heading hover:bg-gray-100 rounded-full p-2 transition-colors" data-id="element-71">
                  <XIcon className="w-5 h-5" data-id="element-72" />
                </button>
              </div>

              <div className="overflow-y-auto px-6 md:px-8 py-6 space-y-5 text-body text-base leading-relaxed" data-id="element-73">
                <section data-id="element-74">
                  <h3 className="font-heading text-lg font-bold text-heading mb-2" data-id="element-75">
                    1. Naturaleza del producto
                  </h3>
                  <p data-id="element-76">
                    "Candidiasis Vaginal: Lo Que Debes Saber" es un producto
                    digital descargable en formato PDF, acompañado de bonos
                    complementarios. Tiene fines exclusivamente educativos e
                    informativos. No constituye una consulta médica, un
                    diagnóstico, ni un tratamiento.
                  </p>
                </section>

                <section data-id="element-77">
                  <h3 className="font-heading text-lg font-bold text-heading mb-2" data-id="element-78">
                    2. Aviso médico
                  </h3>
                  <p data-id="element-79">
                    La información contenida en esta guía no sustituye la
                    evaluación, diagnóstico ni tratamiento de un profesional de
                    la salud. Ante síntomas intensos, persistentes o
                    recurrentes, siempre se debe consultar a un médico o
                    ginecólogo cualificado.
                  </p>
                </section>

                <section data-id="element-80">
                  <h3 className="font-heading text-lg font-bold text-heading mb-2" data-id="element-81">
                    3. Acceso y entrega
                  </h3>
                  <p data-id="element-82">
                    Una vez completada la compra, el acceso al PDF y a los bonos
                    se entrega de forma inmediata mediante descarga digital. Es
                    responsabilidad del usuario verificar que cuenta con un
                    dispositivo y conexión adecuados para descargar y visualizar
                    los archivos.
                  </p>
                </section>

                <section data-id="element-83">
                  <h3 className="font-heading text-lg font-bold text-heading mb-2" data-id="element-84">
                    4. Uso personal
                  </h3>
                  <p data-id="element-85">
                    La compra otorga una licencia de uso personal e
                    intransferible. Queda prohibida la reproducción,
                    distribución, reventa, copia parcial o total, así como
                    compartir los archivos con terceros por cualquier medio
                    físico o digital.
                  </p>
                </section>

                <section data-id="element-86">
                  <h3 className="font-heading text-lg font-bold text-heading mb-2" data-id="element-87">
                    5. Propiedad intelectual
                  </h3>
                  <p data-id="element-88">
                    Todo el contenido —textos, gráficos, diseño y materiales
                    adicionales— está protegido por las leyes de propiedad
                    intelectual aplicables. Su uso indebido podrá dar lugar a
                    acciones legales.
                  </p>
                </section>

                <section data-id="element-89">
                  <h3 className="font-heading text-lg font-bold text-heading mb-2" data-id="element-90">
                    6. Política de reembolso
                  </h3>
                  <p data-id="element-91">
                    Debido a la naturaleza digital e inmediata del producto, las
                    descargas se consideran finales. Si tras adquirir y revisar
                    la guía consideras que no obtuviste el valor esperado,
                    podrás solicitar una revisión de tu caso conforme a la
                    política de satisfacción descrita en la página de venta.
                  </p>
                </section>

                <section data-id="element-92">
                  <h3 className="font-heading text-lg font-bold text-heading mb-2" data-id="element-93">
                    7. Limitación de responsabilidad
                  </h3>
                  <p data-id="element-94">
                    El uso de la información contenida en la guía es bajo
                    responsabilidad exclusiva del usuario. No se garantizan
                    resultados específicos ni se asume responsabilidad por
                    decisiones tomadas a partir de su lectura sin la
                    correspondiente orientación médica profesional.
                  </p>
                </section>

                <section data-id="element-95">
                  <h3 className="font-heading text-lg font-bold text-heading mb-2" data-id="element-96">
                    8. Modificaciones
                  </h3>
                  <p data-id="element-97">
                    Nos reservamos el derecho de actualizar o modificar estos
                    términos en cualquier momento. Las modificaciones entrarán
                    en vigor desde su publicación en esta página.
                  </p>
                </section>

                <section data-id="element-98">
                  <h3 className="font-heading text-lg font-bold text-heading mb-2" data-id="element-99">
                    9. Aceptación
                  </h3>
                  <p data-id="element-100">
                    La realización de la compra implica la aceptación plena de
                    estos términos y condiciones.
                  </p>
                </section>
              </div>

              <div className="px-6 md:px-8 py-4 border-t border-gray-100 flex justify-end" data-id="element-101">
                <button onClick={() => setIsOpen(false)} className="bg-button text-white px-6 py-2.5 rounded-full font-semibold hover:bg-[#A88BA8] transition-colors" data-id="element-102">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}